module.exports = __webpack_public_path__ + "static/media/ic_pet3.475e408b.png";